// One guard for every link in the app (RT-X02).
//
// Profile links, apply links and other URLs people type end up in
// `<a href={...}>` in dozens of places, and React 18 still renders a
// `javascript:` href (it only warns). Clicking one runs script on this
// origin, where the login token lives in localStorage. The server now refuses
// and filters these, but a value stored before that, or a field nobody has
// found yet, would still reach an href, so the click is stopped here too.
const BAD_SCHEME = /^(javascript|data|vbscript):/i;

export function isUnsafeHref(href) {
  const raw = String(href ?? "");
  // Ask the browser's own URL parser for the scheme. A hand-written pattern
  // misses what the parser forgives: it drops ANY leading control character,
  // so "\x01javascript:..." got past `^\s*` and still ran (RT-X12).
  try {
    if (BAD_SCHEME.test(new URL(raw, "https://www.siftcareers.com/").protocol)) return true;
  } catch {
    // Not parseable as a URL; the check below still applies.
  }
  // Belt and braces, and the only check if URL is missing: strip every
  // control character and space (leading ones are dropped, and tabs and
  // newlines are ignored inside a scheme, "java\tscript:").
  const visible = Array.from(raw).filter((ch) => ch.charCodeAt(0) > 0x20).join("");
  return BAD_SCHEME.test(visible);
}

export function installLinkGuard(doc = document) {
  const stop = (e) => {
    const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (a && isUnsafeHref(a.getAttribute("href"))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };
  doc.addEventListener("click", stop, true);
  doc.addEventListener("auxclick", stop, true);
  // window.open is the other way a typed URL gets followed (apply buttons).
  const w = doc.defaultView;
  if (w && w.open && !w.open.__siftGuarded) {
    const open = w.open.bind(w);
    const guarded = (url, ...rest) => (isUnsafeHref(url) ? null : open(url, ...rest));
    guarded.__siftGuarded = true;
    w.open = guarded;
  }
}
